import {
  MDBAlert,
  MDBBtn,
  MDBContainer,
  MDBFile,
  MDBIcon,
  MDBInput,
  MDBModalFooter,
  MDBSelect,
  MDBSpinner,
  MDBTabs,
  MDBTabsContent,
  MDBTabsItem,
  MDBTabsLink,
  MDBTabsPane,
} from "mdb-react-ui-kit";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  updateExistingGreetings,
  uploadEditGreeting,
  uploadGreeting,
} from "../../../apiclients/streamsapi_bridge";
import { getAudioFile, getAudioFileNew } from "../../../components/mediaplayers/AudioPlayer";
import ReactRecorder from "../../../components/VoiceRecorder/ReactRecorder";
import TexttoSpeech from "../../MediaLibrary/TexttoSpeech";
import TexttoSpeechgGreeting from "../../MediaLibrary/TexttoSpeechgGreeting";
import { Controller, useForm } from "react-hook-form";
import { sanitizeAndLowercase } from "../../../apiclients/CommonUtils";
import { Tooltip } from "react-tooltip";
import { customSearchFn } from "../../../components/CustomSearchUtil/CustomSearch";
import UIConstant from "../../../apiclients/UIConstant";
import GreetingAlertPopup from "../../../apiclients/GreetingAlertPopup";

export default function Greeting(props) {
  const { t } = useTranslation();
  const [filePath, setFilePath] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [mediaLibAudioPath, setMediaLibAudioPath] = useState("");
  const [mediaLibAudioWav, setMediaLibAudioWav] = useState(null);
  const [mediaFileName, setmediaFileName] = useState("");
  const [mediaLib, setMediaLib] = useState([]);

  const [uploadedAudioPath, setUploadedAudioPath] = useState("");

  const [failedErrorMessage, setFailedErrorMessage] = useState("");

  const [disableDone, setDisableDone] = useState(false);

  const [activeTab, setActiveTab] = useState("tab4");

  const [selectedMediaObj, setSelectedMediaObj] = useState(null);

  const [fileUploadErrorMsg, setFileUploadErrorMsg] = useState(false);

  const [micFileName, setMicFileName] = useState(null);
  const [micRecFile, setMicRecFile] = useState(null);

  const [errorMessage, setErrorMessage] = useState("");
  const [uploadName, setUploadName] = useState("");
  const [micName, setMicName] = useState("");
  const [isloading, setIsloading] = useState(false);
  const [oldText, setoldText] = useState("");
  const [wavFile, setwavFile] = useState(null);
  const [wavFilePath, setwavFilePath] = useState("");
  const [wavFileName, setwavFileName] = useState("");
  const [oldVoiceType, setoldVoiceType] = useState(1);
  const [selectOpen, setSelectOpen] = useState(false);
  const [isStreamingAudio, setIsStreamingAudio] = useState(false);

  const [showMaxLengthConfirm, setShowMaxLengthConfirm] = useState(false);
  const pendingSubmitRef = useRef(null);
  const ref = useRef(null);

  const maxChars = props.huntFlag
    ? UIConstant.MAX_CHAR_MEDIA_HUNT
    : UIConstant.MAX_CHAR_MEDIA;

  const {
    register,
    watch,
    handleSubmit,
    formState: { isDirty, dirtyFields, errors },
    setValue,
    clearErrors,
    control,
    reset,
    setError,
  } = useForm({
    defaultValues: {
      name: "",
      filename: "",
      voice_type: 1,
      text: "",
    },
  });

  const handleBasicClick = (value) => {
    if (value === activeTab) {
      return;
    }
    setActiveTab(value);
    setErrorMessage("");
    setFileUploadErrorMsg("");
  };

  const [selectedOptionGreetingMode, setSelectedGreetingMode] = useState(
    props.greetingMode ?? 0,
  ); // Default to Personalized

  // Personalized / Default greeting change event case.
  const changeGreetingMode = (event) => {
    setSelectedGreetingMode(+event.target.value);
  };

  // On Choose File
  const handleFileUpload = (eventData) => {
    setFileUploadErrorMsg(false);
    eventData.stopPropagation();
    const file = eventData.target.files?.[0];
    if (file) {
      const fileUrl = URL.createObjectURL(file);
      // verifying the weather the file  if mp3 / wav file or not
      let fileext = file.name.split(".")[1];
      if (
        (fileext && !(fileext.includes("wav") || fileext.includes("mp3"))) ||
        file.size / (1024 * 1024) >= 25
      ) {
        // setting the error and returning back the control.
        setFileUploadErrorMsg(true);
      }
      // removking existing audio path for memory leaks
      if (uploadedAudioPath) {
        URL.revokeObjectURL(uploadedAudioPath);
      }

      setUploadedAudioPath(fileUrl);
      setSelectedFile(file);
    } else {
      setUploadedAudioPath("");
      setSelectedFile("");
    }
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        ref.current &&
        !ref.current.contains(e.target) &&
        !e.target.closest(".select-dropdown-container")
      ) {
        setSelectOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // New Greeting File upload.
  async function onFileUpload(tabID) {
    let resJson = { status: 500, message: "Internal Server Error" };
    try {
      setIsloading(true);
      const formData = new FormData();
      formData.append(
        "siteid",
        JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      ); // The account siteId.
      formData.append("greeting_type", props.greetingType); //  greeting type need to be updated.
      formData.append("id", props.uniqueId); // unique ID of the respective module.
      if (props.shareVMFlag) {
        formData.append("vm_greeting", true);
      }

      if (tabID == "tab2") {
        formData.append("greeting", selectedFile); //  file object or the streams data.
        formData.append("filename", selectedFile.name); // Name of the file.
        formData.append("filetype", "." + selectedFile.name.split(".")[1]); //  type of the file either wav or mp3
        formData.append("uploadtype", 1); // either file upload or microphone upload 1- file 2- microphone
        formData.append("name", uploadName); // Name field.
        // if (props.setgeetingTitle) {
        //   props.setgeetingTitle(uploadName);
        // }
      } else if (tabID == "tab3") {
        formData.append("greeting", micRecFile); //  file object or the streams data.
        formData.append("filename", micFileName + ".mp3"); // Name of the file.
        formData.append("filetype", ".mp3"); //  type of the file either wav or mp3
        formData.append("uploadtype", 2);
        formData.append("name", micName); // Name field.
        // if (props.setgeetingTitle) {
        //   props.setgeetingTitle(micName);
        // }
      }

      //formData.append('name', 'name input in UI'); //  popups have only name component.
      let apiResponse = await uploadGreeting(formData);
      setTimeout(() => {
        setIsloading(false);
      }, 2000);
      let resdata = await apiResponse.json();
      if (apiResponse.status) {
        resJson = resdata;
        resJson.status = apiResponse.status;
        resJson.message = resdata.message;
        resJson.code = resdata.greeting_id;
        resJson.greeting_type = props.greetingType
      }
      console.log(`onFileUpload -> JSON Response:${JSON.stringify(resdata)}`);
    } catch (error) {
      console.log(`Unable to upload the file:${error}`);
    }
    return resJson;
  }

  // on change media library
  async function onMediaSelect(infoObj) {
    if (infoObj && infoObj != -1) {
      setIsloading(true);
      let response = await getAudioFileNew(
        infoObj.id,
        infoObj.greeting_type,
        infoObj.greeting_id,
        infoObj.filename
      );
        if (response.status === 200) {
      const blobfile = await response.blob();
      const audioFilePath = URL.createObjectURL(blobfile);
      // setmediaFileName(infoObj?.display ?? "");
      setMediaLibAudioPath(audioFilePath ?? "");
      setMediaLibAudioWav(blobfile ?? "");
      handleBlur();
      setTimeout(() => {
        setIsloading(false);
        handleBlur();
      }, 1000);
      setSelectedMediaObj({ ...(infoObj ?? {}) });
    }
    } else {
      setMediaLibAudioPath("");
      setMediaLibAudioWav(null);
    }
  }

  //media library select option
  useEffect(() => {
    if (props.existingGreetings && props.existingGreetings?.length > 0) {
      console.log(`Existing reeting::${props.existingGreetings}`);
      let selectOption = { text: "--Select a Greeting--", value: -1 };
      let framedMediaArr = props.existingGreetings?.map((obj) => ({
        text: obj.display,
        value: obj,
      }));
      setMediaLib([selectOption, ...(framedMediaArr ?? [])]);
    }
  }, [props.existingGreetings]);

  // updating the greetings.
  async function updateGreeting() {
    let resJson = { status: 500, message: "Internal Server Error" };
    try {
      let infoDto = selectedMediaObj;
      setIsloading(true);
      let updateGreJson = {
        siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
        greeting_type: infoDto.greeting_type,
        greetingSettingType: infoDto.greetingSettingType,
        refid: infoDto.refId,
        greeting_id: infoDto.greeting_id,
        id: infoDto.id ?? props.uniqueId,
        filename: infoDto.filename,
        active: 1,
        greeting_mode: 1,
        ...(props.shareVMFlag ? { vm_greeting: true } : {}),
      };
      let apiResponse = await updateExistingGreetings(updateGreJson);
      setTimeout(() => {
        setIsloading(false);
      }, 1000);
      let resdata = await apiResponse.json();
      if (apiResponse.status) {
        resJson = resdata;
        resJson.greeting_id = resdata?.greeting_id
        resJson.status = apiResponse.status;
        resJson.message = resdata.message;
        resJson.code = resdata.greeting_id;
        resJson.display = infoDto?.display;
      }
      console.log(`updateGreeting ->JSON Response:${JSON.stringify(resdata)}`);
    } catch (error) {
      console.log(`Unable to update greeting : ${error}`);
    }

    return resJson;
  }

  // updating the greetings.
  async function updateDefualtGreeting() {
    let resJson = { status: 500, message: "Internal Server Error" };
    try {
      setIsloading(true);
      let updateGreJson = {
        siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
        greeting_type: props.greetingType,
        greeting_id: 0,
        id: props.uniqueId,
        filename: "",
        active: 1,
        greeting_mode: 2, //  default
        ...(props.shareVMFlag ? { vm_greeting: true } : {}),
      };
      let apiResponse = await updateExistingGreetings(updateGreJson);
      setTimeout(() => {
        setIsloading(false);
      }, 1000);
      let resdata = await apiResponse.json();
      if (apiResponse.status) {
        resJson = resdata;
        resJson.status = apiResponse.status;
        resJson.message = resdata.message;
        resJson.greeting_type = props.greetingType
        resJson.code = 0
      }
      console.log(
        `updateDefualtGreeting ->JSON Response:${JSON.stringify(resdata)}`,
      );
    } catch (error) {
      console.log(`Unable to update defualt greeting : ${error}`);
    }

    return resJson;
  }

  // For any kind of upload.
  async function saveChanges(event, tabID) {
    try {
      event.preventDefault();
      event.stopPropagation();
      let playerPath = "";
      let greetname = "";
      let playerwavFile = "";
      let response = {};
      setFailedErrorMessage("");

      if (selectedOptionGreetingMode === 1) {
        switch (tabID) {
          case "tab1":
            if (props.uniqueId && (props.uniqueId * 1 > 0 || props.userFlag)) {
              response = await updateGreeting();
              playerPath = mediaLibAudioPath; // updating the audio path for playing in main page.
              playerwavFile = mediaLibAudioWav;
              greetname = selectedMediaObj?.display ?? "";
            } else {
              // This case is executed only from annoucement node.
              selectedMediaObj.code = selectedMediaObj.greeting_id;
              props.setApiResponse(
                selectedMediaObj,
                selectedOptionGreetingMode,
              );
              if(props.callFlowFlag  && selectedMediaObj?.uploadType === 3) {
          props.setPlayerPath(mediaLibAudioPath, mediaLibAudioWav);
        } else {
        props.setPlayerPath(mediaLibAudioPath);
        }
              if (props.setgeetingTitle) {
                props.setgeetingTitle(mediaFileName ?? "");
              }
              props.onClose(); // closing the popup.
            }
            break;
          case "tab2":
            response = await onFileUpload(tabID);
            playerPath = uploadedAudioPath; // updating the audio path for playing in main page.
            greetname = uploadName;
            break;
          case "tab3":
            response = await onFileUpload(tabID); // sending the microphone request.
            if (playerPath) {
              // revoking the exisitng blob url for memory leaks.
              URL.revokeObjectURL(playerPath);
            }
            playerPath = URL.createObjectURL(micRecFile);
            greetname = micName;
            break;
        }
      } else {
        // Sending request for default greeting.
        response = await updateDefualtGreeting();
        playerPath = "";
        props.setgeetingTitle("");
      }

      // 200- success , 500 - Internal server error, 204 - No Content found error, 403 - Already entry exists.
      if (response.status === 200) {
        // success message  need to display.
        console.log(`Greeting Response.:: ${response.message}`);
        if (selectedMediaObj) {

          selectedMediaObj.greeting_id = response?.greeting_id ?? selectedMediaObj.greeting_id
        }
        response = { ...response, display: greetname, ...(tabID === "tab1" && selectedMediaObj?.uploadType === 3 ? { ...selectedMediaObj, uploadType: 3 } : {}) };
        response.greeting_type = response?.greetingSettingType ?? response?.greeting_type
        // set the Succcesss Status message to front end.
        props.setApiResponse(response, selectedOptionGreetingMode);
        if (props.callFlowFlag && tabID === "tab1" && selectedMediaObj?.uploadType === 3) {
          props.setPlayerPath(playerPath, playerwavFile);
        } else {
          props.setPlayerPath(playerPath);
        }
        if (props.setgeetingTitle && greetname) {
          props.setgeetingTitle(greetname);
        }
        if (props.setDynamicValues && tabID === "tab1" && selectedMediaObj?.uploadType === 3) {
          selectedMediaObj.greeting_id = response?.code //{...selectedMediaObj,greeting_id : response?.code,greeting_type:response?.greetingSettingType}
          selectedMediaObj.greeting_type = response?.greetingSettingType
          props.setDynamicValues(selectedMediaObj);

        }
        props.onClose(); // closing the popup.
      } else if (
        response.status === 500 ||
        response.status === 204 ||
        response.status === 403 ||
        response.status === 400
      ) {
        setFailedErrorMessage(response.message);
      }
      // alert(JSON.stringify(response));
    } catch (e) {
      console.log(`unable to save the greetings:${e}`);
    }
  }

  const isdirtyFields = Object.keys(dirtyFields).length === 0 ? false : true;

  async function onTTSSubmit(data) {
    try {
      setFailedErrorMessage("");

      if (isdirtyFields) {
        setIsloading(true);
        const formData = new FormData();
        formData.append(
          "siteid",
          JSON.parse(sessionStorage.getItem("admin_session")).siteid,
        );
        formData.append("greeting_type", props.greetingType); //  greeting type need to be updated.
        formData.append("id", props.uniqueId);
        formData.append("voice_type", data.voice_type);
        formData.append("uploadtype", 3);
        formData.append("name", data.name);
        if (props.shareVMFlag) {
          formData.append("vm_greeting", true);
        }
        //formData.append("filename", data.filename + ".wav")
        formData.append("text", data.text);
        // if (props.setgeetingTitle) {
        //   props.setgeetingTitle(data.name);
        // }
        if (
          !isStreamingAudio &&
          oldText === sanitizeAndLowercase(data.text) &&
          parseInt(oldVoiceType) === parseInt(data.voice_type)
        ) {
          formData.append(
            "greeting",
            wavFile,
            data.filename ? data.filename + ".mp3" : "",
          );
          //formData.append("filename", wavFile.name);
          //formData.append("filetype", "." + wavFile.name.split(".")[1]);
          formData.append("filetype", "mp3");
        }

        let apiResponse = await uploadGreeting(formData);
        setTimeout(() => {
          setIsloading(false);
        }, 2000);
        let response = await apiResponse.json();
        response.code = response.greeting_id;
        if (response.status === "success") {
          if (props.setgeetingTitle) {
            props.setgeetingTitle(data.name);
          }
          // success message  need to display.
          console.log(`Greeting Response.:: ${response.message}`);
          response = {
            ...response,
            display: data.name,
            istts: true,
            isNew: true,
            ...(props.callFlowFlag ? {
              ...data,
              greeting_id: response.greeting_id,
              updatedfilename: response.filename,
              id: props.uniqueId,
            } : {}),

          };
          // set the Succcesss Status message to front end.
          props.setApiResponse(response, selectedOptionGreetingMode);
          props.setPlayerPath(wavFilePath);
          if (props.setgeetingTitle) {
            props.setgeetingTitle(data.name);
          }
          if (props.setDynamicValues) {
            props.setDynamicValues({
              ...data,
              greeting_id: response.greeting_id,
              updatedfilename: response.filename,
            });
          }
          props.onClose(); // closing the popup.
        } else if (
          response.status === 500 ||
          response.status === 204 ||
          response.status === 403 ||
          response.status === 400 ||
          response.status === "failed"
        ) {
          if (props.setgeetingTitle) {
            props.setgeetingTitle("");
          }
          setFailedErrorMessage(response.message);
        }
        console.log(`uploadFile -> JSON Response:${JSON.stringify(response)}`);
      }
    } catch (error) {
      setFailedErrorMessage("Internal Server Error");
    }
  }

  async function onTTSUpdateSubmit(data) {
    try {
      setFailedErrorMessage("");

      if (isdirtyFields) {
        setIsloading(true);
        const formData = new FormData();
        formData.append(
          "siteid",
          JSON.parse(sessionStorage.getItem("admin_session")).siteid,
        );
        formData.append("id", props.uniqueId);
        formData.append("greeting_id", props.greetingObject.greeting_id);
        formData.append("uploadtype", 3);
        formData.append("greeting_type", props.greetingType);
        if (props.shareVMFlag) {
          formData.append("vm_greeting", true);
        }
        for (const field of Object.keys(dirtyFields)) {
          if (dirtyFields[field] && data.hasOwnProperty(field)) {
            const value = data[field];

            // Skip null or undefined values
            if (value === null || value === undefined) {
              continue;
            }

            // Handle nested objects (flatten them)
            if (
              typeof value === "object" &&
              !Array.isArray(value) &&
              !(value instanceof File)
            ) {
              for (const subfield of Object.keys(dirtyFields[field])) {
                if (value.hasOwnProperty(subfield)) {
                  formData.append(subfield, value[subfield]);
                }
              }
            }
            // Handle File objects
            else if (value instanceof File) {
              formData.append(field, value);
            }
            // Handle arrays
            else if (Array.isArray(value)) {
              formData.append(field, JSON.stringify(value));
            }
            // Handle primitive values
            else {
              formData.append(field, value);
            }
          }
        }
        if (dirtyFields.text && !dirtyFields.voice_type) {
          formData.append("voice_type", data.voice_type);
        } else if (!dirtyFields.text && dirtyFields.voice_type) {
          formData.append("text", data.text);
        }

        if (
          !isStreamingAudio &&
          oldText === sanitizeAndLowercase(data.text) &&
          parseInt(oldVoiceType) === parseInt(data.voice_type)
        ) {
          formData.append(
            "greeting",
            wavFile,
            data.filename ? data.filename + ".mp3" : "",
          );
          //formData.append("filename", wavFile.name);
          //formData.append("filetype", "." + wavFile.name.split(".")[1]);
          formData.append("filetype", "mp3");
        }

        let apiResponse = await uploadEditGreeting(formData);
        setTimeout(() => {
          setIsloading(false);
        }, 2000);
        let response = await apiResponse.json();
        response.code = response.greeting_id;
        if (response.status === "success") {
          if (props.setgeetingTitle) {
            props.setgeetingTitle(data.name);
          }
          // success message  need to display.
          console.log(`Greeting Response.:: ${response.message}`);
          response = {
            ...response, display: data.name, istts: true,
            ...(props.callFlowFlag ? {
              ...data,
              greeting_id: props.greetingObject.greeting_id,
              updatedfilename: response?.filename ?? null,
              greeting_type: props.greetingType,
              id: props.uniqueId,
              code: props.uniqueId
            } : {
              ...data,
              greeting_id: props.greetingObject.greeting_id
            }),
          };
          // set the Succcesss Status message to front end.
          props.setApiResponse(response, selectedOptionGreetingMode);
          props.setPlayerPath(wavFilePath);
          if (props.setgeetingTitle) {
            props.setgeetingTitle(data.name);
          }
          if (props.setDynamicValues) {
            props.setDynamicValues({
              ...data,
              greeting_id: response.greeting_id,
              updatedfilename: response?.filename ?? null,
            });
          }
          props.onClose(); // closing the popup.
        } else if (
          response.status === 500 ||
          response.status === 204 ||
          response.status === 403 ||
          response.status === 400 ||
          response.status === "failed"
        ) {
          if (props.setgeetingTitle) {
            props.setgeetingTitle("");
          }
          setFailedErrorMessage(response.message);
        }
        console.log(`uploadFile -> JSON Response:${JSON.stringify(response)}`);
      }
    } catch (error) {
      setFailedErrorMessage("Internal Server Error");
    }
  }

  // Enabling or disbaling the done buttton.
  useEffect(() => {
    if (
      (props.greetingMode === 2 &&
        props.greetingMode === selectedOptionGreetingMode) ||
      (selectedOptionGreetingMode === 1 &&
        ((activeTab === "tab1" && mediaLibAudioPath === "") ||
          (activeTab === "tab2" &&
            (uploadedAudioPath === "" ||
              uploadName === "" ||
              uploadName == null)) ||
          (activeTab === "tab3" &&
            (micFileName == null ||
              micFileName === "" ||
              micRecFile == null ||
              micName == "" ||
              micName == null))))
    ) {
      setDisableDone(true);
    } else {
      setDisableDone(false);
    }
  }, [
    activeTab,
    mediaLibAudioPath,
    uploadedAudioPath,
    selectedOptionGreetingMode,
    props.greetingMode,
    micFileName,
    micName,
    micRecFile,
    uploadName,
  ]);

  const handleInputChange = (event) => {
    const { value } = event.target;
    const trimmedValue = value.trim();
    const fileNameRegex = /^([a-zA-Z0-9])([a-zA-Z0-9_\- ])*$/;
    if (trimmedValue === "") {
      setErrorMessage("Name is required.");
      setUploadName(null);
    } else if (!fileNameRegex.test(trimmedValue)) {
      setErrorMessage(
        "Invalid name. Only letters, numbers, underscores, hyphens are allowed.",
      );
      setUploadName(null);
    } else {
      setUploadName(trimmedValue);
      setErrorMessage("");
    }
  };

  const handleMaxLengthCancel = (e) => {
    e?.preventDefault();
    e?.stopPropagation();
    setShowMaxLengthConfirm(false);
    pendingSubmitRef.current = null;
  };

  const handleMaxLengthContinue = () => {
    const truncated = (watch("text") || "").slice(0, maxChars);
    setValue("text", truncated, { shouldDirty: true, shouldValidate: true });
    setShowMaxLengthConfirm(false);
    const action = pendingSubmitRef.current;
    pendingSubmitRef.current = null;
    if (action === "update") {
      handleSubmit(onTTSUpdateSubmit)();
    } else {
      handleSubmit(onTTSSubmit)();
    }
  };

  function handleTTSSubmit(submitType, evnt) {
    evnt?.preventDefault();
    evnt?.stopPropagation();
    if (dirtyFields.voice_type && (watch("text") || "").length > maxChars) {
      pendingSubmitRef.current = submitType;
      setShowMaxLengthConfirm(true);
    } else {
      if (submitType === "update") {
        handleSubmit(onTTSUpdateSubmit)();
      } else {
        handleSubmit(onTTSSubmit)();
      }
    }
  }

  const [isOpen, setIsOpen] = useState(false);

  const handleFocus = () => setIsOpen(true);
  const handleBlur = () => setIsOpen(false);

  const autocompleteRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        autocompleteRef.current &&
        !autocompleteRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);


  return (
    <>
     {!(props.AnnounceCalFlow && props.callFlowFlag) && (<>
      <div className="add-numbermain text-start">
        <div>
          <div className="fw-500">{t("GreetingType")}</div>
          <span className="phrecording">
            {t("DefaultPersonalizedGreeting")}
          </span>
        </div>
        <div className="w-40">
          <select
            className="w-100 form-select"
            onChange={changeGreetingMode}
            value={selectedOptionGreetingMode}
          >
            <option value={1}>Personalized</option>
            <option value={2}>System Default</option>
          </select>
        </div>
      </div>
      <div className="routing-border m-0 pt-1 mb-2"></div>
      </>)}
      <div
        className={
          selectedOptionGreetingMode === 1 ? "text-start" : "d-none text-start"
        }
      >
        <MDBTabs className="mb-3">
          <MDBTabsItem>
            <MDBTabsLink
              onClick={() => handleBasicClick("tab4")}
              active={activeTab === "tab4"}
            >
              Text to Speech
            </MDBTabsLink>
          </MDBTabsItem>

          <MDBTabsItem>
            <MDBTabsLink
              onClick={() => handleBasicClick("tab1")}
              active={activeTab === "tab1"}
            >
              {t("mediaLibrary")}
            </MDBTabsLink>
          </MDBTabsItem>
          <MDBTabsItem>
            <MDBTabsLink
              onClick={() => handleBasicClick("tab2")}
              active={activeTab === "tab2"}
            >
              {t("upload")}
            </MDBTabsLink>
          </MDBTabsItem>
          <MDBTabsItem>
            <MDBTabsLink
              onClick={() => handleBasicClick("tab3")}
              active={activeTab === "tab3"}
            >
              {t("recordonMic")}
            </MDBTabsLink>
          </MDBTabsItem>
          {/*
                            <MDBTabsItem>
                                <MDBTabsLink onClick={() => handleBasicClick('tab4')} active={activeTab === 'tab4'}>
                                    {t("recordonPhone")}
                                </MDBTabsLink>
                            </MDBTabsItem> */}
        </MDBTabs>

        <MDBTabsContent>
          <MDBTabsPane open={activeTab === "tab1"}>
            <div className="huntGreetSelect">
              <div ref={ref} className="w-100 my-2" onClick={(e) => {
                if (e.target.closest(".select-dropdown-container")) return;
                if (selectOpen) return;
                setSelectOpen(true);
              }}>
                <MDBSelect
                  key={activeTab}
                  search
                  className="w-100"
                  data={mediaLib}
                  open={selectOpen}
                  // searchFn={customSearchFn}
                  // open={isOpen}
                  // onFocus={handleFocus}
                  // onBlur={handleBlur}
                  onChange={(e) => {
                    onMediaSelect(e.value);
                    setSelectOpen(false);
                  }}
                />
              </div>
            </div>
            {mediaLibAudioPath && (
              <div className="audio-controls-hunt py-2 d-flex align-items-center">
                <audio
                  controlslist="nodownload"
                  src={mediaLibAudioPath}
                  controls
                  preload="auto"
                ></audio>
              </div>
            )}
          </MDBTabsPane>
          <MDBTabsPane open={activeTab === "tab2"}>
            <div>
              <div>
                <label>
                  Name:<span className="text-danger">*</span>
                </label>
                <div className="w-100 my-2 mb-3">
                  <MDBInput maxLength={60} onChange={handleInputChange} />
                  {errorMessage && (
                    <p className="text-danger">{errorMessage}</p>
                  )}
                </div>
              </div>
              <MDBFile
                id="customFile"
                onChange={handleFileUpload}
                accept=".wav, .mp3"
              />
              <span className="text-secondary">{t("maxuploadsize")}</span>
              {fileUploadErrorMsg && (
                <div className="text-danger">{t("fileUploadErrorMsg")}</div>
              )}
            </div>

            {fileUploadErrorMsg == false && uploadedAudioPath && (
              <div className="audio-controls-hunt py-2 d-flex align-items-center">
                <audio
                  controlslist="nodownload"
                  src={uploadedAudioPath}
                  controls
                ></audio>
                {/* <div className="Record ms-3"></div> */}
                {/* <MDBBtn className="ms-3">
                                        {t("upload")}
                                      </MDBBtn> */}
              </div>
            )}
          </MDBTabsPane>
          <MDBTabsPane open={activeTab === "tab3"}>
            {/* Tab 2 content */}
            <ReactRecorder
              setMicFileName={setMicFileName}
              setMicRecFile={setMicRecFile}
              setMicName={setMicName}
              activeTab={activeTab}
            />
          </MDBTabsPane>
          <MDBTabsPane open={activeTab === "tab4"}>
            <TexttoSpeechgGreeting
              register={register}
              reset={reset}
              setValue={setValue}
              watch={watch}
              errors={errors}
              wavFile={wavFile}
              setwavFile={setwavFile}
              control={control}
              Controller={Controller}
              wavFilePath={wavFilePath}
              setwavFilePath={setwavFilePath}
              setoldText={setoldText}
              oldText={oldText}
              setIsloading={setIsloading}
              setwavFileName={setwavFileName}
              setoldVoiceType={setoldVoiceType}
              oldVoiceType={oldVoiceType}
              huntFlag={props.huntFlag}
              isActive={activeTab === "tab4"}
              greetingObject={props.greetingObject}
              ttswaveFile={props.ttswavFile}
              setIsStreamingAudio={setIsStreamingAudio}
            />
          </MDBTabsPane>
          <MDBTabsPane open={activeTab === "tab5"}>
            {/* Tab 3 content */}

            <MDBContainer>
              <div className="d-flex align-items-center  ">
                <MDBInput label="Where To Call" id="form1" type="text" />
                <MDBBtn className="ms-4">Call</MDBBtn>
                {/* <MDBBtn color="danger" className="ms-4 W-100">End Call</MDBBtn> */}
              </div>
              {/* <p className="text-secondary mt-3">Connected</p> */}
              <p className="text-danger mt-3">
                The recording was not successful
              </p>
              {/* <p className="text-primary mt-3">Your Personalized Greeting is Now Activated</p> */}
            </MDBContainer>
          </MDBTabsPane>
        </MDBTabsContent>
      </div>

      <div
        className={selectedOptionGreetingMode === 2 ? "text-start" : "d-none"}
      >
        <p className="text-secondary my-5">
          The System Default {props.title} will be played
        </p>
      </div>

      <MDBModalFooter className="mt-5">
        <MDBBtn color="secondary" onClick={(e) => props.onClose()}>
          Cancel
        </MDBBtn>
        {props?.greetingObject &&
          props?.greetingObject?.uploadType === 3 &&
          selectedOptionGreetingMode === 1 &&
          activeTab === "tab4" ? (
          <>
            <MDBBtn
              disabled={
                props?.greetingObject &&
                (props?.greetingObject?.title !== "" || props?.greetingObject?.display !== "") &&
                watch("name") &&
                (props?.greetingObject?.title || props?.greetingObject?.display)?.trim() === watch("name")?.trim()
              }
              onClick={(evnt) => handleTTSSubmit("new", evnt)}
            >
              <MDBIcon fas icon="plus" className="me-2" />
              Create New
            </MDBBtn>
            <MDBBtn
              disabled={!isDirty}
              onClick={(evnt) => handleTTSSubmit("update", evnt)}
            >
              Save
            </MDBBtn>
          </>
        ) : (
          <MDBBtn
            disabled={disableDone}
            onClick={(evnt) => {
              if (activeTab === "tab4" && selectedOptionGreetingMode === 1) {
                handleTTSSubmit("new", evnt);
              } else {
                saveChanges(evnt, activeTab);
              }
            }}
          >
            Done
          </MDBBtn>
        )}
      </MDBModalFooter>
      {failedErrorMessage !== "" && (
        <MDBAlert
          open
          className="alert-center"
          color="danger"
          autohide
          position="bottom-right"
          delay={5000}
          onClose={() => setFailedErrorMessage("")}
        >
          {failedErrorMessage}
        </MDBAlert>
      )}
      {isloading && (
        <>
          <div className="loadingclass">
            <MDBBtn disabled>
              <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
              Loading...
            </MDBBtn>
          </div>
        </>
      )}

      <GreetingAlertPopup
        isOpen={showMaxLengthConfirm}
        popupheading="Warning"
        message={`Modifying the message or voice may result in truncation to fit the limit. Are you sure you want to continue?`}
        mode="confirm"
        onContinue={handleMaxLengthContinue}
        onCancel={handleMaxLengthCancel}
      />
    </>
  );
}
